import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTab } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Tab.module.scss';
import { mapMenuTabKeys } from 'client/utils/constants/appStates';

const Tab = ({ item, state }) => {
    const { key, rendered } = item;
    const ref = useRef();
    const { tabProps, isSelected, isDisabled } = useTab({ key }, state, ref);

    const enhancedMeasuresTabClass = key === mapMenuTabKeys.ENHANCED_MEASURES
        ? !isDisabled
            ? styles.enhancedMeasuresTab
            : null
        : null;
    return (
        <div
            {...tabProps}
            data-testid={item?.props['data-testid'] ? item?.props['data-testid'] : null}
            ref={ref}
            className={[
                styles.tab,
                isSelected ? styles.selected : enhancedMeasuresTabClass,
                isDisabled ? styles.disabled : null
            ].join(' ')}
        >
            <span>
                {item?.props?.prefix ? <>{item?.props?.prefix}<br /></> : null}
                {rendered}
            </span>
        </div>
    );
};

Tab.propTypes = {
    ...defaultAriaProps,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool
};

export default Tab;
